import { z } from 'zod'
import { textAnnotationFields } from './text-annotation.dto.js'

/**
 * A static text annotation baked into a venue space's background (e.g.
 * "Dance Floor", "Parking Lot"). Part of the floor plan, not movable furniture.
 * Shared source of truth for the editor's `StaticLabel` type and stored JSON.
 */
export const staticLabelSchema = z.object({
  id: z.string(),
  x: z.number(),
  y: z.number(),
  ...textAnnotationFields,
  rotation: z.number().optional(),
})

export type StaticLabel = z.infer<typeof staticLabelSchema>
